import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "applications"
}
const _hoisted_3 = { class: "responsive-table" }
const _hoisted_4 = {
  key: 1,
  class: "no-applications"
}
const _hoisted_5 = { class: "app-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_application_view = _resolveComponent("application-view")!
  const _component_page = _resolveComponent("page")!

  return (_openBlock(), _createBlock(_component_page, { ref: "pageRef" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.applications.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("ul", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedApplications, (application) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "table-row",
                    key: application
                  }, [
                    _createVNode(_component_application_view, {
                      application: application,
                      onApplicationCancelled: _ctx.refreshApplications
                    }, null, 8, ["application", "onApplicationCancelled"])
                  ]))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, "No Applications Associated")),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "app-btn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.applyForNewLoan && _ctx.applyForNewLoan(...args)))
          }, "Apply for a New Student Loan"),
          (_ctx.canApplyForNewApps)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "other-apps-button app-btn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.viewAllApps && _ctx.viewAllApps(...args)))
              }, " View Other Applications "))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 512))
}